/**
 * Deterministic, dependency-free id derivation for migrations.
 *
 * This is the single most important rule in the migration framework. A migration that
 * minted random ids would be a data-loss bug: two clients running the same migration while
 * offline would produce different ids for the same row, and merging their documents would
 * duplicate every migrated item. Deriving the id from the content means both clients
 * produce byte-identical output, so the merge collapses to one copy.
 *
 * Not a cryptographic hash and it does not need to be — it only has to be stable across
 * platforms and free of collisions within a single recipe.
 */
function fnv1a(input: string, seed: number): number {
  let hash = seed;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

export function deterministicId(...parts: readonly (string | number)[]): string {
  const input = parts.map(String).join('\u0000');
  const a = fnv1a(input, 0x811c9dc5);
  const b = fnv1a(input, 0x9e3779b9);
  return a.toString(16).padStart(8, '0') + b.toString(16).padStart(8, '0');
}
